export default __webpack_public_path__ + "9f7a4412727d47cc13dd4c058b154407.svg";